import { Campaign, Chat } from "@mui/icons-material";
import { Tab, Tabs } from "@mui/material";
import { Box } from "@mui/system";
import { ReactElement, useState } from "react";
import { useAppSelector } from "@common-reducers/hooks/store.hook";
import ScheduledCampaignsList from './scheduled-campaigns-list';
import { ScheduledContactList } from "./scheduled-contact-list";

export function ManageScheduledEvents(): ReactElement {
  const [tabValue, setTabValue] = useState('Scheduled messages');

  const calendarViewOpen = useAppSelector((state) => state.MainReducer.calendarViewOpen);

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  if (!calendarViewOpen) {
    return <></>;
  }

  return (
    (
      <Box sx={{
        boxShadow: '0 5px 12px rgb(0 55 80 / 16%);',
        zIndex: 1000,
        position: 'relative',
        direction: 'inherit',
        backgroundColor: 'transparent',
        height: '100%',
      }}>
        {false &&
          <Tabs
            value={tabValue}
            onChange={handleChange}
            aria-label="icon position tabs example"
            sx={{
              '& .MuiTabs-flexContainer': {
                display: 'flex',
                justifyContent: 'space-evenly !important'
              },
              '& .MuiTabs-indicator': {
                backgroundColor: 'var(--tasks-text-secondary)',
              },
            }}>
            <Tab
              icon={<Chat fontSize='small' />}
              value='Scheduled messages2'
              iconPosition="start"
              label="Scheduled messages"
              sx={{
                height: '40px !important',
                minHeight: '0 !important',
                marginTop: '6px',
                color: '210 40% 96.1%',
                '&.Mui-selected': {
                  color: 'var(--tasks-text-secondary)',
                }
              }} />
            <Tab
              icon={<Campaign />}
              value='Campaigns'
              iconPosition="start"
              label="Campaigns"
              sx={{
                height: '40px !important',
                minHeight: '0 !important',
                marginTop: '6px',
                color: '210 40% 96.1%',
                '&.Mui-selected': {
                  color: 'var(--tasks-text-secondary)',
                }
              }} />
          </Tabs>
        }
        {tabValue === 'Scheduled messages' && <ScheduledContactList />}
        {tabValue === 'Campaigns' && <ScheduledCampaignsList />}
      </Box>
    )
  );
}
